import React from 'react'
import { Box, Col, Dialog,  InputField, Row, Switchbox,  } from '../../../../ppui'
import { STATUTORY_KYC_CONST } from '../statutory-kyc-const'

const EsciUpdateModal = ({ EmployeeESCI, escimodal, TogggleEsciMOdal, orginfoESCI,
  onChnageESCI,
  OnBlureESCI,
  ToggleEsci,
  errorsESCI, UpdateStatutory,updateLoder }) => {

  return (
    <Dialog
      title="Employee Under ESI Scheme"
      secondary={`Code: ${orginfoESCI?.esi_code}`}
      closeButton={true}
      fullWidth
      maxWidth="sm"
      open={escimodal}
      onClose={TogggleEsciMOdal}
      onSubmit={UpdateStatutory}
      btnLoading={updateLoder}
      separator
      buttonName="Update"
      footer={
        <>
        <Box mr={"auto"}>
          <Switchbox disabled={!orginfoESCI?.is_esi} label={`${EmployeeESCI?.esi_availability ? "Disable" : "Enable"} ESI`} color="Primary" name="esi_availability" size="lg"  checked={EmployeeESCI?.esi_availability} onChange={ToggleEsci} />
        </Box>
        </>
      }
    >
     
      <Row rowGap py={20}>
        <Col xs={12} sm={6}>
          <InputField
            error={!!errorsESCI?.esic_insurance_number}
            helperText={errorsESCI?.esic_insurance_number}
            disabled={!EmployeeESCI?.esi_availability}
            valueSinc={!!EmployeeESCI?.esic_insurance_number}
            value={EmployeeESCI?.esic_insurance_number}
            onChange={(e) => onChnageESCI(e, "esic_insurance_number")}
            onBlur={(e) => OnBlureESCI(e, "esic_insurance_number")}
            {...STATUTORY_KYC_CONST.esic_insurance_number}
          />
        </Col>

        <Col xs={12} sm={6}>
          <InputField
            error={!!errorsESCI?.esic_registration_date}
            helperText={errorsESCI?.esic_registration_date}
            disabled={!EmployeeESCI?.esi_availability}
            valueSinc={!!EmployeeESCI?.esic_registration_date}
            value={EmployeeESCI?.esic_registration_date}
            onChange={(e) => onChnageESCI(e, "esic_registration_date")}
            onKeyDown={(e) => e.preventDefault()}
            onBlur={(e) => OnBlureESCI(e, "esic_registration_date")}
            {...STATUTORY_KYC_CONST.esic_registration_date}
          />
        </Col>

        <Col xs={12} sm={6}>
          <InputField
            error={!!errorsESCI?.esic_card_attachment}
            helperText={EmployeeESCI?.esic_card_attachment?.name || EmployeeESCI?.esic_card_attachment?.slice(0, 14)}
            disabled={!EmployeeESCI?.esi_availability}
            onChange={(e) => onChnageESCI(e, "esic_card_attachment", "file")}
            onBlur={(e) => OnBlureESCI(e, "esic_card_attachment")}
            {...STATUTORY_KYC_CONST.esic_card_attachment}
          />
        </Col>
      </Row>
    </Dialog>
  )
}

export default EsciUpdateModal